export default __webpack_public_path__ + "static/media/GTorpedoClosed.2a88f926.jpg";